/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const formSubmissionScoreDataSchema = z.object({
	percentage: z.number(),
	total: z.number(),
	max: z.number(),
	breakdown: z.array(
		z.object({
			questionId: z.string(),
			rawScore: z.number(),
			weight: z.number(),
			weightedScore: z.number(),
			maxScore: z.number(),
		}),
	).nullable(),
})

export type FormSubmissionScoreDataSchema = z.infer<typeof formSubmissionScoreDataSchema>
